export default {
  methods: {
    getMainInstance () {
      return this.$router.currentRoute.matched[0].instances.default
    }
  }
}
